<template>
  <div class="container">
    <div class="top_title">会员注册/绑定</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="weui-cells item" style="border: 0!important;margin-top: 2.4rem">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>类别</p>
          </div>
          <div class="weui-cell__ft SEX">
            <span :class="{active: info.I_TYPE_FLG == '会员'}" @click="info.I_TYPE_FLG = '会员'">会员</span>
            <span :class="{active: info.I_TYPE_FLG == '非会员'}" @click="info.I_TYPE_FLG = '非会员'">非会员</span>
          </div>
        </div>
        <div v-if="info.I_TYPE_FLG != '非会员'" class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__bd">
            <p>校区</p>
          </div>
          <div class="weui-cell__ft">
            <select class="weui-select" v-model="info.I_SCHOOL_NAME" style="color:#bbb">
              <option value=''>请选择</option>
              <option v-for="item in info.dataList" :value='item.I_SCHOOL_NAME'>{{item.I_SCHOOL_NAME}}</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>姓名</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text" v-model="info.I_STUDENT_NAME" placeholder="请输入宝贝姓名" style="width: 14rem;"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>年龄</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text" v-model="info.I_AGE" placeholder="请输入宝贝年龄(2.5~12岁)" style="width: 14rem;"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>性别</p>
          </div>
          <div class="weui-cell__ft SEX">
            <span :class="{active: info.I_SEX == '男孩'}" @click="info.I_SEX = '男孩'">男孩</span>
            <span :class="{active: info.I_SEX == '女孩'}" @click="info.I_SEX = '女孩'">女孩</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>我是</p>
          </div>
          <div class="weui-cell__ft family_member">
            <span :class="{active: info.I_RELATION_SHIP == '爸爸'}" @click="info.I_RELATION_SHIP = '爸爸'">爸爸</span>
            <span :class="{active: info.I_RELATION_SHIP == '妈妈'}" @click="info.I_RELATION_SHIP = '妈妈'">妈妈</span>
            <span :class="{active: info.I_RELATION_SHIP == '其他'}" @click="info.I_RELATION_SHIP = '其他'">其他</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>手机</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text tel" v-model="info.I_TEL" style="padding-right: 0.4rem" placeholder="请输入手机号"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>验证码</p>
          </div>
          <div class="weui-cell__ft identify_code">
            <input type="text" v-model="info.I_IDENTIFY_CODE" placeholder="请输入验证码" />
            <button type="button" :disabled="disabled" @click="sendcode" class="btns">{{btntxt}}</button>
          </div>
        </div>
      </div>

      <button class="bottom_btn" @click="save">注册</button>

      <div class="contact_ways">
        <p v-for="item in info.dataList2">{{item.I_SCHOOL_CONNECT}}</p>
        <p>{{info.I_NOTICE}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {
          dataList:[],
          I_RELATION_SHIP: "",
          I_SEX: ""
        },
        btntxt: "获取验证码",
        disabled: false,
      }
    },
    created() {
      DataRequestFactory.I020010().then((response) => {
        response.I_SEX = ""
        response.I_TYPE_FLG = ""
        response.I_AGE = ""
        this.info = response

        if(this.info.I_TEL == null || this.info.I_TEL == "") {
          this.I_IDENTIFY_FLAG = "Y"
        }

    })
    },
    methods: {
      //验证手机号码部分
      sendcode() {
        // var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if(this.info.I_TEL == '' || this.info.I_TEL == null){
          weui.topTips("请输入手机号码");
        // }else if(!reg.test(this.info.I_TEL)){
        //   weui.topTips("手机格式不正确");
        }else {
          this.time = 60;
          this.disabled = true;
          this.timer();
          let requestParams = {
            "I_TYPE": "手机验证码",
            "I_TEL": this.info.I_TEL,
          }
          DataRequestFactory.C020010(requestParams).then((response) => {
            if(response.resultCode == 0) {
            console.log(response)
          }
        })
        }
      },
      timer() {
        if (this.time > 0) {
          this.time--;
          this.btntxt = this.time+"s后重新获取";
          setTimeout(this.timer, 1000);
        } else{
          this.time=0;
          this.btntxt="获取验证码";
          this.disabled=false;
        }
      },
      save () {
        let requestParams =
        {
          I_TYPE_FLG: this.info.I_TYPE_FLG,
          I_SCHOOL_NAME: this.info.I_SCHOOL_NAME,
          I_STUDENT_NAME: this.info.I_STUDENT_NAME,
          I_RELATION_SHIP: this.info.I_RELATION_SHIP,
          I_TEL: this.info.I_TEL,
          I_SEX: this.info.I_SEX,
          I_AGE: this.info.I_AGE,
          I_IDENTIFY_FLAG: this.I_IDENTIFY_FLAG,
          I_IDENTIFY_CODE: this.info.I_IDENTIFY_CODE
        }
        DataRequestFactory.I020011(requestParams).then((response) => {
          if(response.resultCode == 0) {
          this.$router.push({ name: 'H030010'})
          weui.topTips("保存成功");
        }
      })
      }
    },
    mounted() {

      var win_h = $(window).height();  //关键代码
      $("body").height(win_h);  //关键代码
    },
    watch: {
      'info.I_TYPE_FLG': {
        handler: function(val,val1) {
          if(val == '非会员') {
            this.info.I_SCHOOL_NAME = ""
          }
        },
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H020010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H020010.vue